export const REGISTER_CUSTOMER_REQUEST = 'registercustomer/REGISTER_CUSTOMER_REQUEST';
export const REGISTER_CUSTOMER_SUCCESS = 'registercustomer/REGISTER_CUSTOMER_SUCCESS';
export const REGISTER_CUSTOMER_FAILURE = 'registercustomer/REGISTER_CUSTOMER_FAILURE';